import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/style.css";
import ScrollToTop from "./components/scroll-top";

const container = document.getElementById("root");
const app = (
  <BrowserRouter>
    <ScrollToTop />
    <App />
  </BrowserRouter>
);

// Prerendered pages ship real HTML in #root — hydrate it; dev serves an
// empty shell — render normally.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app, { onRecoverableError: () => {} });
} else {
  ReactDOM.createRoot(container).render(app);
}

reportWebVitals();
